import { toString } from 'lodash';
import { DataEditorProps, ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { SelectValueViewer } from 'components';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS_OPTIONS,
  getFundInvestmentMarketAdjustmentMetricKey,
} from 'pages/FundInvestments/common/constants';
import { HandleCompanyTitleCellsParams } from './handleCompanyTitleCells.types';

const {
  metric_selection_as_of_date: METRIC_SELECTION_AS_OF_DATE,
  metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE,
} = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const { metric_selection: METRIC_SELECTION } = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const handleCompanyTitleCells = (params: HandleCompanyTitleCellsParams): void => {
  const { cell, colNumber, metricSelection, title } = params;

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_DATE.column:
      Object.assign(cell, {
        className: `${cell.className} right-aligned`,
        customKey: METRIC_SELECTION.key,
        dataEditor: (props: DataEditorProps) => (
          <GridSelect
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: GridSelect is not typed
            menuPosition="fixed"
            options={FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS_OPTIONS}
            {...props}
          />
        ),
        dbType: 'string',
        gridType: 'string',
        hidden: false,
        isRequired: true,
        readOnly: false,
        value:
          getFundInvestmentMarketAdjustmentMetricKey(metricSelection)
          ?? toString(FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS_OPTIONS?.[0]?.value),
        valueViewer: (props: ValueViewerProps) => (
          <SelectValueViewer options={FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS_OPTIONS} {...props} />
        ),
      });
      break;

    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      Object.assign(cell, {
        expr: `=FROM_KEY(${JSON.stringify(FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_METRICS)}, ${
          METRIC_SELECTION.key
        })`,
      });
      break;

    default:
      Object.assign(cell, {
        value: title,
      });
      break;
  }
};

export default handleCompanyTitleCells;
